import { Canvas } from "@react-three/fiber"
import { PointerLockControls, KeyboardControls, Box, useHelper } from "@react-three/drei"
import { Physics } from "@react-three/rapier"
import { Player } from "./Player"
import { Suspense, useRef } from "react"
import { LevelStart } from "./levels/level-start"
import { FPSMonitor } from "./components/elements/fps-motion"
import { ToastContainer } from "react-toastify"
import { PlayerNote } from "./components/elements/player-note"
import { PlayerSubmits } from "./components/elements/player-submits"
import { SupportForm } from "./components/elements/support-form"
import { HomeScreen } from "./components/elements/home-screen"
import { Triangle } from "react-loader-spinner"

const MyLoader = () => {

  return (
    <div className="wait-load">
      <Triangle
        height="80"
        width="80"
        radius="9"
        color="grey"
        ariaLabel="loading"
      />
    </div>
  )
}

export default function App() {


  return (
    <>
      <KeyboardControls
        map={[
          { name: "forward", keys: ["ArrowUp", "w", "W"] },
          { name: "backward", keys: ["ArrowDown", "s", "S"] },
          { name: "left", keys: ["ArrowLeft", "a", "A"] },
          { name: "right", keys: ["ArrowRight", "d", "D"] },
        ]}>
        <Suspense fallback={<MyLoader />}>
          {/*<FPSMonitor />*/}
          <Canvas shadows camera={{ fov: 45 }}>
            <Physics debug={false} gravity={[0, -30, 0]}>
              <LevelStart />
              <Player />
            </Physics>
          </Canvas>
          <ToastContainer
            position="top-right"
            autoClose={1500}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            theme="dark"
          />
          <PlayerNote />
          <PlayerSubmits />
          <SupportForm />
        </Suspense>
      </KeyboardControls>
      <HomeScreen />
    </>
  )
}
